import { render, staticRenderFns } from "./index.vue?vue&type=template&id=04b49a1c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b49a1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04b49a1c')) {
      api.createRecord('04b49a1c', component.options)
    } else {
      api.reload('04b49a1c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=04b49a1c&scoped=true", function () {
      api.rerender('04b49a1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/TierSetting/index.vue"
export default component.exports